export default __webpack_public_path__ + "static/media/grid.dd288232.svg";